import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { ReactComponent as MessageIcon } from '../assets/MessageIcon.svg';
import { ReactComponent as MessageIconBlue } from '../assets/MessageIconBlue.svg';
import { ReactComponent as JobIcon } from '../assets/JobIcon.svg';
import { ReactComponent as JobIconBlue } from '../assets/JobIconBlue.svg';
import { ReactComponent as InProgress } from '../assets/InProgress.svg';
import { ReactComponent as InProgressBlue } from '../assets/InProgressBlue.svg';
import { ReactComponent as Profile } from '../assets/Profile.svg';
import { ReactComponent as ProfileBlue } from '../assets/ProfileBlue.svg';
import { ThemeProvider } from '@mui/material/styles';
import { Typography } from '@mui/material';
import theme from '../views/candidate/theme';
import { ServerURL } from '../serverURL';

export default function BottomNav() {
  const location = useLocation();

  const [value, setValue] = React.useState(0);
  const [unreadCount, setUnreadCount] = useState(0);
  const [unreadmsg, setUnreadMsg] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
  const [unreadCountProfile, setUnreadCountProfile] = useState(0);

  React.useEffect(() => {
    const path = location.pathname;  
    if (path.includes('/mypage')) {
      setValue(0);
    } else if (path.includes('/messages')) {
      setValue(1);
    } else if (path.includes('/inprogress')) {
      setValue(2);
    } else if (path.includes('/profile')) {
      setValue(3);
    } else {
      // Add additional checks for detail pages related to each tab
      if (path.includes('/mypage/') || path.includes('/recruitment') || path.includes('/searchinfo')) {
        setValue(0);
      } else if (path.includes('/messages/') || path.includes('/secretentrydetail') || path.includes('/corporatescoutFullInfo')) {
        setValue(1);
      } else if (path.includes('/inprogress/') || path.includes('/fullprogress') || path.includes('/documentscreeningentry') 
        || path.includes('/documentscreeningconfirm') || path.includes('/chat')) {
        setValue(2);
      } else if (path.includes('/profile/') || path.includes('/maskingresume') || path.includes('/recommendedjob') || path.includes('/messagetemplate') || path.includes('/createmessage')
        || path.includes('/editmessage') || path.includes('/editmessage') || path.includes('/terms') || path.includes('/privacy') || path.includes('/changememberid')
        || path.includes('/corporate-block') || path.includes('/changepassword') || path.includes('/editmaskingresume') || path.includes('/notifications')) {
        setValue(3);
      } else if (path === '/agent' || '/agent-log' || '/agent-log-information') {
        setValue(4); // Assuming 4 is the index for the specific menu item you want to activate
      } else {
        setValue(0); // Default value for unrecognized paths
      }
    }

    fetchUnreadCounts();
    fetchNotifications(); 
    fetchUnreadMessage();   
  }, [location.pathname]);

  // Fetch unread notification in the profile --> regarding the new bugs and feature item
  const fetchNotifications = async () => {
    const authKey = localStorage.getItem('authKey');  
    if (!authKey) {
      console.error('Auth key not found in sessionStorage');
      return;
    }
    try {
      const response = await fetch(`${ServerURL.PRODUCTION_HOST_URL}candidates/get_notification_list`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${authKey}`,
        },
      });

      if (!response.ok) {
        throw new Error('ネットワークエラー発生しました。インタネットの接続を確認しください');
      }

      const data = await response.json();
      // Set unread count for profile notification
      setUnreadCountProfile((data.stats && typeof data.stats.unread_count === 'number') ? data.stats.unread_count : 0);
      // Optionally keep the old logic for other uses
      const hasUnread = data.notifications_list.some(notification => notification.is_read === "No");
      setHasUnreadNotifications(hasUnread);
    } catch (error) {
      setHasUnreadNotifications();
      setUnreadCountProfile(0);
    }
  };

  const fetchUnreadCounts = async () => {
    const authKey = localStorage.getItem('authKey');  
    if (!authKey) {
      console.error('Auth key not found in sessionStorage');
      return;
    }
    try {
      const response = await fetch(`${ServerURL.PRODUCTION_HOST_URL}candidates/get_chat_unread_counts`, {
        method: 'GET',
          headers: {
            Authorization: `Bearer ${authKey}`,
        },
      });
      const data = await response.json();
      if(response.ok){
        setUnreadCount(data.chat_stat_details.total_unread_count ? data.chat_stat_details.total_unread_count : 0);
      } else if(!response.ok) {
        console.error('No notifications');
        setUnreadCount(0);
      }
    } catch (error) {
      setUnreadCount(0);
    }
  };
 
  const fetchUnreadMessage = async () => {
    const authKey = localStorage.getItem('authKey');  
    if (!authKey) {
      console.error('Auth key not found in sessionStorage');
      return;
    }
    try {
      const response = await fetch(`${ServerURL.PRODUCTION_HOST_URL}candidates/get_corporate_scout_unread_counts`, {
        method: 'GET',
          headers: {
            Authorization: `Bearer ${authKey}`,
        },
      });
      const data = await response.json();
      
      // Update unread count only if it's not null
      const unreadmsg = data.corporate_scout_stat_details.corporate_scout_unread_count;
      setUnreadMsg(unreadmsg ?? 0); // Set 0 if it's null
    } catch (error) {
      setUnreadMsg(0);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box className='candidate-fixed-bottom-nav' sx={{ width: '100%', position: 'fixed', left: '0', bottom: '0', background: '#fff' }}>
        <BottomNavigation
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          <BottomNavigationAction
            label={<Typography className='bottomnav-title' variant="body2" sx={{ fontSize: '12px', marginTop: '7px'}}>求人情報</Typography>}
            icon={value === 0 ? <JobIconBlue /> : <JobIcon />}
            component={RouterLink}
            to="/mypage"
            sx={{ '& > span': {fontSize: '12px', '& .MuiTouchRipple-root': {
              width: '100%',
              height: '100%',
            },} }}
          />

          <BottomNavigationAction
            label={<Typography className='bottomnav-title' variant="body2" sx={{ fontSize: '12px', marginTop: '7px'}}>メッセージ</Typography>}
            icon={
              <div style={{ position: 'relative', display: 'inline-flex' }}>
                {value === 1 ? <MessageIconBlue /> : <MessageIcon />}
                
                {/* Conditionally show the notification dot if unreadCount > 0 */}
                {unreadmsg > 0 && (
                  <span
                    style={{
                      position: 'absolute',
                      top: '-4px',
                      right: '-4px',
                      display: 'inline-block',
                      width: '8px',
                      height: '8px',
                      backgroundColor: 'red',
                      borderRadius: '50%',
                    }}
                  />
                )}
              </div>
            }
            component={RouterLink}
            to="/messages"
            sx={{ '& > span': { fontSize: '12px' } }}
          />

          <BottomNavigationAction
            label={
              <Typography className='bottomnav-title' variant="body2" sx={{ fontSize: '12px', marginTop: '7px'}}>
                進行中
              </Typography>
            }
            icon={
              <div style={{ position: 'relative', display: 'inline-flex' }}>
                {value === 2 ? <InProgressBlue /> : <InProgress />}
                {unreadCount > 0 && (
                  <span
                    style={{
                      position: 'absolute',
                      top: '-4px',
                      right: '-4px',
                      display: 'inline-block',
                      width: '8px',
                      height: '8px',
                      backgroundColor: 'red',
                      borderRadius: '50%',
                    }}
                  />
                )}
              </div>
            }
            component={RouterLink}
            to="/inprogress"
            sx={{ '& > span': {fontSize: '12px' } }}
          />
          <BottomNavigationAction
            label={<Typography className='bottomnav-title' variant="body2" sx={{ fontSize: '12px' }}>プロフィール</Typography>}
            icon={
              <div style={{ position: 'relative', height: '23.6px'}}>
                {value === 3 ? <ProfileBlue /> : <Profile />}
                {unreadCountProfile > 0 && (
                  <span className='profile-notification-dot'></span>
                )}
              </div>
            }
            component={RouterLink}
            to="/profile"
            sx={{ '& > span': { fontSize: '12px' } }}
          >
          </BottomNavigationAction>
        </BottomNavigation>
      </Box>
    </ThemeProvider>
  );
}
